'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'cherries';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e0ec';
var svgPathData = ['M0 336C0 224 96 224 96 224c30.6 0 56.3 9.5 73.5 18.2c7.1 3.6 12.7 7 16.6 9.6c3.8 2.5 5.9 4.2 5.9 4.2c0 0 .3-.3 .8-.6s1.2-.9 2.2-1.6c2-1.4 4.8-3.3 8.5-5.5c7.4-4.5 18.1-10.1 31.4-14.8c14.9-5.3 33-9.5 53.1-9.5c0 0 96 0 96 112c0 160-144 176-192 176S0 480 0 336zM353.9 488.9c36-32 62.1-80.9 62.1-152.9c0-53.1-18.7-88.3-43.2-110.5c17.1 2.4 32.1 7.4 44.1 12.7C436.4 246.7 448 256 448 256s7.2-5.7 19.7-12.4c17-9 44-19.6 76.3-19.6c0 0 96 0 96 112c0 160-144 176-192 176c-20.3 0-57.6-5.7-94.1-23.1z', 'M300.5 19.5L288 40c12.5-20.5 12.5-20.5 12.5-20.5s0 0 0 0c0 0 0 0 0 0l.1 .1 .4 .3c.3 .2 .8 .5 1.4 .9c1.2 .8 2.9 1.9 5.1 3.4c4.3 2.9 10.4 7.2 17.6 12.7c14.5 11.1 34 27.4 54.1 48.5c35.4 37.3 74 91 88.3 158.2C455.2 250.3 448 256 448 256s-11.6-9.3-31.2-17.9c-14-48.4-43.1-88.9-72.2-119.6c-14.7-15.5-29.1-28.1-41-37.6c-3.1 11.7-7.4 25.7-13.1 41.3C279 154.1 261.3 193 234.9 233.5C208.4 242.9 192 256 192 256s-8.3-6.6-22.5-13.8c38.6-48.8 62.1-98.1 76-136.4c7.6-21 12.4-38.5 15.2-50.7c1.4-6.1 2.3-10.8 2.9-13.9c.3-1.6 .5-2.7 .6-3.5l.1-.8 0-.1s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0L269.1 .3l31.4 19.2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCherries = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;